import { Link as RouterLink, type LinkProps } from '@tanstack/react-router'
import { Link as MuiLink, type LinkProps as MuiLinkProps } from '@mui/material'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

export type LinkWithArrowProps = LinkProps &
  MuiLinkProps & {
    label: string
  }

export function LinkWithArrow({ label, ...rest }: LinkWithArrowProps) {
  return (
    <MuiLink
      className={rest.disabled ? 'Mui-disabled' : undefined}
      component={RouterLink}
      {...rest}
      sx={{
        ...rest.sx,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.7
      }}
    >
      {label}
      <ArrowRightAltIcon fontSize="small" />
    </MuiLink>
  )
}
